"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MappingSchema = exports.FunnelSchema = exports.MappingMetricSchema = void 0;
const zod_1 = require("zod");
exports.MappingMetricSchema = zod_1.z.object({
    id: zod_1.z.number(),
    metric_id: zod_1.z.number(),
    position: zod_1.z.number(),
    is_mapping_goal: zod_1.z.boolean(),
});
exports.FunnelSchema = zod_1.z.object({
    id: zod_1.z.number(),
    name: zod_1.z.string(),
    aov: zod_1.z.number().nullable().optional(),
    position: zod_1.z.number(),
    metrics: zod_1.z.array(exports.MappingMetricSchema),
});
exports.MappingSchema = zod_1.z.object({
    id: zod_1.z.number(),
    name: zod_1.z.string(),
    funnels: zod_1.z.array(exports.FunnelSchema),
});
//# sourceMappingURL=schemas.js.map